<template>
  <main class="w-full pb-20">
    <section class="px-3 py-6 rounded-lg bg-white border-2 border-green-600">
      <div class="w-full">
        <!-- Table Menu -->
        <div class="sm:flex-wrap flex mb-4 items-start justify-between">
          <div class="flex flex-row flex-wrap items-center">
            <SearchBar
              class="mb-3"
              placeholder="Cari data kabupaten/kota..."
              @input="onSearch($event)"
            />
          </div>
          <div class="flex flex-row gap-2">
            <LinkButton
              href="kabupaten-kota/tambah"
              title="Tambah Kabupaten/Kota"
              data-cy="district__button-add"
            >
              <template #icon-left>
                <JdsIcon
                  name="plus"
                  size="14px"
                  fill="#fff"
                  class="h-[14px] w-[14px]"
                />
              </template>
              <p class="font-lato font-bold text-sm text-white leading-none">
                Tambah Kabupaten/Kota
              </p>
            </LinkButton>
          </div>
        </div>
        <div class="w-full overflow-auto">
          <DistrictTable
            :items="districts"
            :loading="loading"
            :meta="meta"
            class="min-w-[1000px]"
            @update:pagination="onUpdatePagination($event)"
          />
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import SearchBar from '@/common/components/SearchBar';
import LinkButton from '@/common/components/LinkButton';
import DistrictTable from '@/components/Profiles/District/DistrictTable.vue';

import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const districtRepository = RepositoryFactory.get('district');

export default {
  name: 'District',
  components: {
    SearchBar,
    LinkButton,
    DistrictTable,
  },
  data() {
    return {
      districts: [],
      meta: {
        total_count: 0,
        total_page: 0,
        current_page: 1,
        per_page: 10,
      },
      params: {
        per_page: 10,
        page: 1,
        q: '',
      },
      loading: false,
    };
  },
  async mounted() {
    await this.fetchDistrict();
  },
  methods: {
    async fetchDistrict() {
      try {
        this.loading = true;

        const response = await districtRepository.getDistricts(this.params);
        const { data, meta } = response.data;

        this.districts = data;
        this.meta = meta;
      } catch (error) {
        this.$toast({
          type: 'error',
          message: 'Gagal mendapatkan data District, silakan coba beberapa saat lagi',
        });
      } finally {
        this.loading = false;
      }
    },
    /**
     * Set new query params based on argument
     *
     * @param {object} data - object containing new params
     */
    setParams(data) {
      const newParams = { ...this.params, ...data };
      this.params = { ...newParams };
    },

    /**
     * Set new params when search input changes
     * and fetch events again
     *
     * @param {string} query - search query
     */
    onSearch(query) {
      this.setParams({ q: query, page: 1 });
      this.fetchDistrict();
    },

    /**
     * Set new params when pagination changes
     * and fetch events again
     *
     * @param {object} data - object cotaining new param based on emit values
     * @property {string} page
     * @property {string} per_page
     */
    onUpdatePagination(data) {
      this.setParams(data);
      this.fetchDistrict();
    },
  },
};
</script>
